'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/yearFromNow.js
// module id = 397
// module chunks = 1